import CloseIcon from './CloseIcon.jsx';
import { useState, useEffect, useRef } from 'react';
import './AlertToast.css';
let listeners = [], toastId = 0;
export function pushToast(toast) { const t = {id:++toastId,ts:Date.now(),...toast}; listeners.forEach(fn=>fn(t)); return t.id; }
export function useToastBridge() { return {pushToast}; }
export default function AlertToast({onGoto,onHeight}) {
  const [toasts,setToasts] = useState([]);
  const ref = useRef(null);
  useEffect(()=> { const receive=t=>setToasts(prev=>[...prev,t].slice(-10)); listeners.push(receive); return ()=>{listeners=listeners.filter(fn=>fn!==receive);}; },[]);
  const current = toasts[0];
  useEffect(()=> { if(!current)return; let visibleMs=0;const timer=setInterval(()=>{if(document.querySelector('[aria-modal="true"]') || ref.current?.matches(':hover') || ref.current?.contains(document.activeElement))return;visibleMs+=1000;if(visibleMs>=10000)setToasts(prev=>prev.filter(t=>t.id!==current.id));},1000);return()=>clearInterval(timer); },[current?.id]);
  useEffect(()=> {
    if (!current || !ref.current) { onHeight?.(0); return; }
    const measure = () => onHeight?.(Math.ceil(ref.current.getBoundingClientRect().height));
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(ref.current);
    return () => { observer.disconnect(); onHeight?.(0); };
  },[current?.id,onHeight]);
  if(!current)return null;
  const reentry = current.category === 'reentry' || /reentry/i.test(current.title);
  const dismiss=()=>setToasts(prev=>prev.filter(t=>t.id!==current.id));
  return <div ref={ref} className="og-alert-slot">
    <div className={`og-alert-card${reentry ? ' og-alert-card--reentry' : ''}`}>
      <span className="og-alert-emblem" aria-hidden="true">{reentry ? '↘' : '!'}</span>
      <div role="alert" className="og-alert-copy">
        <div className="og-alert-heading">{reentry ? 'Predicted reentry' : current.title}</div>
        {reentry && <div className="og-alert-time">{current.timing || current.title.replace(/^⚠\s*REENTRY\s*/i, '')}</div>}
        {current.body && <div className="og-alert-body">{current.body}</div>}
      </div>
      {(current.norad_1 || current.lat != null) && <button className="og-alert-open" onClick={()=>{onGoto?.(current);dismiss();}} aria-label={`Open alert: ${current.title}`}>View <span aria-hidden="true">↗</span></button>}
      <button title="Close" className="og-alert-dismiss og-close-control" onClick={dismiss} aria-label={`Dismiss alert: ${current.title}`}><CloseIcon /></button>
    </div>
  </div>;
}
